import { all, call, put, select, takeEvery } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { getAllDesignsResponse, getDesignByIdResponse, patchEntityList } from "../actions";
import { axiosPost } from "../../utils/common/axios";
import { createEntitySagas, extractPayloadAndCallback, notifyError, notifySuccess } from "./sagaHelpers";

export const designEntity = createEntitySagas({
  entity: "design",
  endpoint: "designs",
  label: "Design",
  scope: "company",
  computedFields: ["brandName", "manufacturerName", "requirementName", "designerName", "versionCount", "versions"],
  selectSlice: (state) => state.design,
  listKey: "designs",
  types: {
    getAll: types.GET_ALL_DESIGNS,
    getById: types.GET_DESIGN_BY_ID,
    create: types.CREATE_DESIGN,
    update: types.UPDATE_DESIGN,
    remove: types.DELETE_DESIGN,
  },
  actions: { getAllResponse: getAllDesignsResponse, getByIdResponse: getDesignByIdResponse },
});

// payload: { designId, uploadedDate, status, revisionSummary, frontImage, backImage }
function* uploadVersionSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { designId, ...version } = payload;
  const list = yield select(designEntity.selectList);
  const previous = list.find((d) => String(d.id) === String(designId));
  try {
    if (previous) {
      const nextNumber = (previous.currentVersion || 0) + 1;
      yield put(
        patchEntityList("design", "merge", {
          id: designId,
          changes: {
            currentVersion: nextNumber,
            revisionsUsed: (previous.revisionsUsed || 0) + (previous.currentVersion ? 1 : 0),
            versionCount: (previous.versionCount || 0) + 1,
            versions: [...(previous.versions || []), { ...version, id: `tmp-${Date.now()}`, versionNumber: nextNumber }],
          },
        }),
      );
    }
    const { data } = yield call(axiosPost, `designs/${designId}/versions`, version);
    callback?.success?.(data);
    notifySuccess("New design version uploaded");
    yield* designEntity.refresh();
  } catch (e) {
    if (previous) yield put(patchEntityList("design", "replace", { id: designId, item: previous }));
    notifyError(e, "Upload failed — the revision limit may have been reached");
    callback?.failure?.(e);
  }
}

export function* designSaga() {
  yield all([call(designEntity.watcher), takeEvery(types.UPLOAD_DESIGN_VERSION, uploadVersionSaga)]);
}
